import { action, observable } from 'mobx';
import Api from '../../api';
import { diContainer, serviceNames } from '../../diContainer/diContainer';
import { IDropdownOption } from '../../domain/entities/Config/Config';

export interface IAddressTreeNode extends IDropdownOption {
  // children for current json record
  subtree?: IAddressTreeNode[];
}

export interface IAddressTrees {
  [key: string]: IAddressTreeNode[];
}

export default class AddressTreeNodesRepository {
  @observable addressTrees: IAddressTrees = {};

  private api: Api;

  constructor() {
    this.api = diContainer.get(serviceNames.apiSdk);
  }

  public getAddressTreeName(
    staticDataDataName: string,
    locale: string,
    countryId: number,
  ): string {
    return `${staticDataDataName}_${locale}_${countryId}`;
  }

  // Get static json data by url
  // Currently, only address (state, city, and/or locker) uses the static data
  @action
  getAddressTree = async (
    params: {
      staticLookupName: string;
      staticDataLookupUrl: string;
      locale: string;
      countryId: number;
    },
  ): Promise<IAddressTreeNode[]> => {
    const {
      staticDataLookupUrl, locale, countryId, staticLookupName,
    } = params;
    const addressTreeName = this.getAddressTreeName(staticLookupName, locale, countryId);
    if (!Object.keys(this.addressTrees).includes(addressTreeName)) {
      if (staticDataLookupUrl && staticLookupName) {
        this.addressTrees[addressTreeName] = [];
        // Use locale to get different static json for different language on same site.
        // [locale] placeholder can be removed once we can get different configs by language id.
        const staticLookupPath = staticDataLookupUrl.replace('[locale]', locale).replace('[countryId]', countryId.toString());
        const staticJson = await this.api.getStaticJsonByPath(staticLookupPath);
        this.addressTrees[addressTreeName] = (staticJson && staticJson.length > 0)
          ? staticJson : undefined;
      }
    }
    return this.addressTrees[addressTreeName];
  };
}
